import { FC } from "react";
import Typography from "../../../components/Typography";
import { ColorNames } from "../../../theme";

interface FormTitleProps {
  title: string;
}
const FormTitle: FC<FormTitleProps> = ({ title }) => {
  return (
    <Typography variant="h1" align="left" color={ColorNames.GREEN}>
      {title}
    </Typography>
  );
};

export default FormTitle;
